import ModalBase from "../modals/ModalBase";
import { copyPortalLink, markPortalLinkSent, portalEmailDraft } from "../../js/api/portalLink";
import { resolveProIdentity } from "../../js/api/proIdentity";

export default function SendPortalLinkModal({ client, session, isOpen, onClose, registered = false }) {
  if (!client) return null;
  const identity = resolveProIdentity(session) || {};
  const kind = client.role_type === "seller" ? "seller" : "buyer";
  const draft = portalEmailDraft({
    client,
    advisorName: identity.name || session?.name || "Your advisor",
    support: identity.email || session?.email || "",
  });

  function send() {
    markPortalLinkSent(client, session);
    window.location.href = draft.mailto;
    onClose();
  }

  function copy() {
    copyPortalLink(client, session).then(() => onClose()).catch(() => onClose());
  }

  return (
    <ModalBase isOpen={isOpen} title="Send portal link" onClose={onClose} compact quiet>
      <p>
        {registered ? "Client registered. " : ""}
        Send the correct portal link to: <strong>{client.name}</strong>?
      </p>
      <p className="muted">
        Client ID {client.client_code} · {kind === "seller" ? "Seller" : "Buyer"} portal only
      </p>
      <div className="btn-row">
        {kind === "buyer" ? (
          <button type="button" className="primary-btn" onClick={send}>
            Send Buyer Portal Link
          </button>
        ) : (
          <button type="button" className="primary-btn" onClick={send}>
            Send Seller Portal Link
          </button>
        )}
        <button type="button" className="ghost-btn" onClick={copy}>
          Copy Link
        </button>
        <button type="button" className="ghost-btn" onClick={onClose}>
          Cancel
        </button>
      </div>
    </ModalBase>
  );
}
